module.exports = __webpack_public_path__ + "img/mp-solution-bg-4.fc429609.jpg";